import React, { useState } from 'react'
import SettingPage from './SettingPage'
import HelpPage from './HelpPage'
import RulesPage from './RulesPage'
import { Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane'
import PageContentLayout from '../components/layouts/PageContentLayout'
import MasterLayout from '../components/layouts/MasterLayout'

const InfoSetting = () => {


    const [activeTab, setActiveTab] = useState("setting");



    const handleTabChange = (key) => {
        setActiveTab(key);
    };


    return (
        <MasterLayout>
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                <TabPane tab="Setting" key="setting">
                    <SettingPage />
                </TabPane>
                <TabPane tab="Helps" key="helps">
                    <HelpPage />
                </TabPane>
                <TabPane tab="Rules" key="rules">
                    <RulesPage />
                </TabPane>
            </Tabs>
        </MasterLayout>

    )
}

export default InfoSetting
